<template>
  <nav
    class="navbar"
    style="background-color: black; padding: 15px !important ;position: relative !important;
  display: flex !important;"
  >
    <div class="logo disbk1">
      <a href="#" @click="$router.push('/')"> <img :src="imgPath+'images/logo.png'" alt="Image" /> </a>
    </div>

    <div class="col-6 col-md-4 setce">
      <div style="font-size: 17px; color: #fff">
        <span class="setbtn"> {{ currentshow.showtime }}</span>
      </div>
  

    </div>
    <div class="user-menu" style="display: flow-root; text-align: end">
      <div class="setname">{{ currentshow.movie }}</div>
      <div style="font-size: 12px; color: #fdba16">
        <span> {{Languages[currentshow.lang]}} </span> <span style="color: #fff">| </span>
        <span> {{currentshow.diamen==null?'2D':'3D'}} </span> <span style="color: #fff">| </span> <span> {{ currentshow.cert }} </span>
      </div>
    </div>
  </nav>
  <section class="search-box">
    <div class="container">
      <h6>Type movie or tv show name to find it</h6>
      <form>
        <input type="search" placeholder="Search here" />
        <input type="submit" value="FIND" />
      </form>
      <ul>
        <li><a href="#">Pulp Function </a></li>
        <li><a href="#">Henry Porter </a></li>
        <li><a href="#">The Racer </a></li>
      </ul>
    </div>
  </section>
  <header class="page-header" >
  </header>
</template>
<script>
export default {
  props:{
      currentshow:{type:Object}
  },
  data:()=>({
      certclass:{"U":"ce1","U/A":"ce2","A":"ce3"},
      imgPath: process.env.BASE_URL,
      Languages:{"1":"Malayalam",'2':"Tamil",'3':"Hindi",'4':"English",'5':"Telugu",'6':"Kannada"},
  }),
  computed:{
  }

}
</script>
